"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const Resource_1 = __importDefault(require("../../../Resource"));
class SubPatrimoineCompositionCorporationResponseResource extends Resource_1.default {
}
exports.default = SubPatrimoineCompositionCorporationResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SubPatrimoineCompositionCorporationResponseResource.prototype, "patrimoineImmobilier", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SubPatrimoineCompositionCorporationResponseResource.prototype, "patrimoineFinancier", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SubPatrimoineCompositionCorporationResponseResource.prototype, "titresScpiOpci", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SubPatrimoineCompositionCorporationResponseResource.prototype, "liquiditesTresorerie", void 0);
